export default function initHotspotModals() {
    // Get all hotspot buttons
    const hotspotButtons = document.querySelectorAll('[id^="hotspot-"]');
    const hotspotModals = document.querySelectorAll('.hotspot-modal');
    const closeButtons = document.querySelectorAll('.hotspot-modal-close');
    const body = document.querySelector('body');

    // Add click event listeners to hotspot buttons
    hotspotButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const hotspotId = button.id;
            const modalId = hotspotId.replace('hotspot-', 'hotspot-modal-');
            const modal = document.getElementById(modalId);

            if (modal) {
                modal.classList.remove('hidden');
                body.style.overflow = 'hidden'; // Prevent background scrolling
            }
        });
    });

    // Add click event listeners to close buttons
    closeButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const modal = button.closest('.hotspot-modal');
            if (modal) {
                modal.classList.add('hidden');
                body.style.overflow = ''; // Restore scrolling
            }
        });
    });

    // Add click event listeners to modal backdrops
    hotspotModals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
            // Check if click is on the modal background (not the content area)
            if (e.target === modal) {
                modal.classList.add('hidden');
                body.style.overflow = ''; // Restore scrolling
            }
        });
    });

    // Add escape key listener
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const activeModal = document.querySelector('.hotspot-modal:not(.hidden)');
            if (activeModal) {
                activeModal.classList.add('hidden');
                body.style.overflow = ''; // Restore scrolling
            }
        }
    });
}
